var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChevronRightRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 25.5,
    width: 25,
    height: 25,
    rx: 12.5,
    transform: "rotate(-90 0.5 25.5)",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 19L16 13L10 7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 25.5,
    width: 25,
    height: 25,
    rx: 12.5,
    transform: "rotate(-90 0.5 25.5)",
    stroke: ""
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightRound);
export default __webpack_public_path__ + "static/media/chevron-right-round.f89feafc92587949bc2cdc1ba7ab42c2.svg";
export { ForwardRef as ReactComponent };